export default {
  index: '首頁',
  logOut: '退出登錄',
  profile: '個人中心',
  webcomeBack: '歡迎回來',
  noName: '暫無名稱',
  changeLogo: '更換公司Logo',
  logoFormatError: '請上傳正確格式的圖片，如png、jpg、jpeg、gif',
  innerAccount: "內部賬號",
};
